import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { CmpsCaLiveEvaluationModule } from '../live-evaluation';
import { CmpsCaScoreSectionModule } from '../score-section';

import { CaAnalysisDialogComponent } from './ca-analysis-dialog.component';
import { TranslationIdMap as DialogTranslationIdMap } from './ca-analysis-dialog.i18n';
import { CaAnalysisDialogService } from './ca-analysis-dialog.service';

@NgModule({
    declarations: [CaAnalysisDialogComponent],
    providers: [CaAnalysisDialogService],
    imports: [
        CmpsButtonModule,
        CmpsCaLiveEvaluationModule,
        CmpsCaScoreSectionModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(DialogTranslationIdMap),
        CmpsTooltipModule,
        CommonModule,
    ],
})
export class CmpsCaAnalysisDialogModule {}
